import { render, staticRenderFns } from "./UnsubscribeSuccessful.vue?vue&type=template&id=24f7e06a&scoped=true&"
import script from "./UnsubscribeSuccessful.js?vue&type=script&lang=js&"
export * from "./UnsubscribeSuccessful.js?vue&type=script&lang=js&"
import style0 from "./UnsubscribeSuccessful.scss?vue&type=style&index=0&id=24f7e06a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7e06a",
  null
  
)

export default component.exports